import { PopoverAchievementsComponent } from '@1bill-app/components/popover-achievements/popover-achievements.component';
import { PopoverOnebillPointsComponent } from '@1bill-app/components/popover/popover-onebill-points/popover-onebill-points.component';
import {
  EXPLANATION_NOTES_SIMPLE,
  ROUTE_CONNECT_EMAIL,
  ROUTE_EMAIL_SCANNER,
  ROUTE_MOBILE_NUMBER,
  ROUTE_OFFERS,
  ROUTE_POINTS_INFO,
  ROUTE_SETTINGS_NOTIFICATION,
  ROUTE_SETTINGS_PAYMENT_INFO,
  ROUTE_UPLOAD_FIRST_BILL,
} from '@1bill-app/constants';
import { HomeService } from '@1bill-app/services/home/home.service';
import { RewardQuery } from '@1bill-app/services/reward/reward.query';
import {
  Reward,
  RewardActionCodeMapping,
  RewardState,
} from '@1bill-app/services/reward/reward.type';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, Input, OnInit } from '@angular/core';
import { NavController, PopoverController } from '@ionic/angular';
import { first, orderBy } from 'lodash';

@Component({
  selector: 'app-complete-profile',
  templateUrl: './complete-profile.component.html',
  styleUrls: ['./complete-profile.component.scss'],
  animations: [
    trigger('visibilityChanged', [
      state('shown', style({ opacity: 1 })),
      state('hidden', style({ opacity: 0 })),
      transition('* => *', animate('.5s')),
    ]),
  ],
})
export class CompleteProfileComponent implements OnInit {
  constructor(
    private navCtrl: NavController,
    private homeService: HomeService,
    private popoverController: PopoverController,
    private rewardQuery: RewardQuery,
  ) {}
  
  @Input() firstName: string;
  @Input('loading') loading: boolean;
  totalPointsBalance$ = this.rewardQuery.totalPointsBalance$;
  pointsInfoRoute = ROUTE_POINTS_INFO;
  offersRoute = ROUTE_OFFERS;

  @Input() set rewardState(state: RewardState) {
    this.totalProfilePoint = state.tpp;
    this.filteredRewards = state.rewards.filter(
      (reward) => state.pcaCodes.indexOf(reward.actionCode) >= 0,
    );
    this.rewardBadges = state.rewards.filter(
      (reward) => reward.showBadge == 1 && reward.completed == 1,
    );
    this.profileCompletePoints = state.tpp || state.ttp;

    this.totalProfilePointsCompleted = state.tppc;
    this.profilePointsCompletedRatio = state.ppRatio;
    this.oldUser = state.oldUser;

    if (this.totalProfilePointsCompleted === this.profileCompletePoints || this.oldUser) {
      this.accordionState = 'collapse';
    }
  }
  @Input() set initialAccoridinState(value: 'expand' | 'collapse') {
    this.accordionState = value;
    this.accordionToggleText = this.accordionState === 'expand' ? 'View Less' : 'View All';
  }
  public totalProfilePoint: number;
  public filteredRewards: Reward[];
  public rewardBadges: Reward[];
  public profileCompletePoints: number;
  public profilePointsCompletedRatio: number;
  public oldUser: boolean;
  public totalProfilePointsCompleted: number;
  public accordionState: 'expand' | 'collapse' = 'collapse';
  // Determines text content of the accordion toggle based on whether or not the list is expanded or collapsed.
  public accordionToggleText = this.accordionState === 'expand' ? 'View Less' : 'View All';

  get nextTaskReward() {
    return first(
      orderBy(
        this.filteredRewards.filter((reward) => reward.completed != 1),
        ['rewardPoints'],
      ),
    );
  }

  get otherTaskRewards() {
    const nextTask = this.nextTaskReward;
    return this.filteredRewards.filter((reward) => reward !== nextTask);
  }

  ngOnInit() {}
  toggleAccordionState() {
    this.accordionState = this.accordionState === 'expand' ? 'collapse' : 'expand';
    this.accordionToggleText = this.accordionState === 'expand' ? 'View Less' : 'View All';
  }
  async presentPopover(reward: Reward) {
    const popover = await this.popoverController.create({
      component: PopoverAchievementsComponent,
      cssClass: 'my-custom-class',
      // translucent: true,
      mode: 'ios',
      componentProps: {
        reward: reward,
      },
    });
    return await popover.present();
  }
  getPointsText(data: Reward) {
    let txt = data.rewardPoints + '';
    const rewardType =
      typeof data?.rewardType === 'string' ? data.rewardType.toLowerCase() : '';
    if (rewardType.includes('qantas frequent flyer')) {
      txt += ' 1bill pts';
    }
    if (!data.completed) {
      txt = '+ ' + txt;
    }
    return txt;
  }
  renderPointItemClass(data) {
    const classNames = [];
    if (this.accordionState === 'expand') {
      classNames.push('expand');
    } else {
      classNames.push('collapse');
    }
    if (data.completed) {
      classNames.push('complete');
    } else {
      classNames.push('incomplete');
    }
    return classNames.join(' ');
  }
  /* getAccumulatedPoint(type: 'value' | 'ratio' = 'value') {
    const value = this.filteredRewards.reduce((a, b) => {
      if (b.completed) {
        a += b.rewardPoints;
      }
      return a;
    }, 0);
    if (type == 'ratio') {
      return value / this.profileCompletePoints;
    }
    if (type == 'value') {
      return value;
    }
  } */

  get pointAccumulationText() {
    if (!Array.isArray(this.filteredRewards)) return 0;
    const totalPoints = this.profileCompletePoints;

    return `${this.totalProfilePointsCompleted}/${totalPoints}\u00A0pts`;
  }

  routePointsInfo() {
    this.navCtrl.navigateForward([ROUTE_POINTS_INFO]);
  }
  onItemClick(data: Reward) {
    if (data.completed) return;
    switch (data.actionCode) {
      case RewardActionCodeMapping.ADD_FIRST_BILL:
        this.navCtrl.navigateForward([ROUTE_UPLOAD_FIRST_BILL]);
        break;
      case RewardActionCodeMapping.ADD_PAYMENT_DETAILS:
        this.navCtrl.navigateForward([ROUTE_SETTINGS_PAYMENT_INFO]);
        break;
      case RewardActionCodeMapping.SET_NOTIFICATION:
        this.navCtrl.navigateForward([ROUTE_SETTINGS_NOTIFICATION]);
        break;
      case RewardActionCodeMapping.VERIFY_MOBILE_NUMBER:
        this.navCtrl.navigateForward([ROUTE_MOBILE_NUMBER]);
        break;
      case RewardActionCodeMapping.FIRST_CONNECT_EMAIL_WITH_SUPPLIER:
        this.navCtrl.navigateForward([ROUTE_CONNECT_EMAIL]);
        break;
      case RewardActionCodeMapping.EMAIL_SCANNER:
        this.navCtrl.navigateForward([ROUTE_EMAIL_SCANNER]);
        break;
      case RewardActionCodeMapping.LINK_BANK_ACCOUNT:
        this.linkBankAccounts();
        break;
    }
  }

  linkBankAccounts() {
    this.homeService.presentLinkBankAccountModal();
  }

  async presentInfoPopover() {
    const popover = await this.popoverController.create({
      component: PopoverOnebillPointsComponent,
      cssClass: 'onebill-points-modal',
      // translucent: true,
      mode: 'ios',
      componentProps: {
        popoverTitle: EXPLANATION_NOTES_SIMPLE.POINTS_TITLE,
        description: EXPLANATION_NOTES_SIMPLE.POINTS_DESC,
      },
    });
    return await popover.present();
  }

  trackByRewardActionFn(index: number, item: Reward) {
    return item?.rewardActionId;
  }
}
